/* eslint-disable */
const itemsToShow = 9;

const loadMoreCards = () => {
	const servicesSection = document.querySelectorAll('.block-services-cards');

	servicesSection.forEach((section) => {
		const loadMoreButton = section.querySelector('.load-more-button');
		const cards = section.querySelectorAll('.block-service-card');

		// hide all cards except first itemsToShow
		cards.forEach((card, index) => {
			if (index >= itemsToShow) {
				card.classList.remove('is-active');
			}
		});

		hideLoadMoreButton(section);

		loadMoreButton.addEventListener('click', () => {
			const cards = section.querySelectorAll('.block-service-card');
			const activeCards = section.querySelectorAll(
				'.block-service-card.is-active'
			);
			const cardsToShow = activeCards.length + itemsToShow;

			cards.forEach((card, index) => {
				if (index < cardsToShow) {
					card.classList.add('is-active');
				}
			});

			hideLoadMoreButton(section);
		});
	});
};

const hideLoadMoreButton = (section) => {
	const cards = section.querySelectorAll('.block-service-card');
	const activeCards = section.querySelectorAll(
		'.block-service-card.is-active'
	);
	const loadMoreButton = section.querySelector('.load-more-button');
	if (cards.length - activeCards.length <= 0) {
		loadMoreButton.style.display = 'none';
	}
};

loadMoreCards();
/* eslint-enable */
